import PopoverBase from '../../../../common/Popover/PopoverBase';
import PopoverListItem from '../../../../common/Popover/PoppoverListItem';
import { BaseAttribute } from '../../../ontology/types/attributeTypes';
import ActionList from './ActionList';
import {
	Dispatch,
	FunctionComponent,
	MouseEventHandler,
	SetStateAction,
	useMemo,
	useState,
} from 'react';

interface ExpandingListItemProps extends BaseAttribute {
	canEdit: boolean;
	attrWithActiveSubmenu: number | null;
	setOpenAttribute: Dispatch<SetStateAction<number | null>>;
}

const ExpandingListItem: FunctionComponent<ExpandingListItemProps> = ({
	attrWithActiveSubmenu,
	setOpenAttribute,
	canEdit,
	...attrProps
}) => {
	const { _id, singular: label } = attrProps;

	const [anchorEl, setAnchorEl] = useState<HTMLLIElement | null>(null);

	const submenuOpen = useMemo(
		() => attrWithActiveSubmenu === _id,
		[attrWithActiveSubmenu, _id]
	);

	const onItemClick: MouseEventHandler = (e) => {
		e.stopPropagation();
		if (canEdit) {
			setOpenAttribute((p) => {
				if (p && p === _id) {
					return null;
				}

				return _id;
			});
		}

		return;
	};

	return (
		<>
			<PopoverListItem
				ref={setAnchorEl as any}
				button
				// icon={faCube}
				textContent={label}
				onClick={onItemClick}
			/>

			<PopoverBase
				anchorEl={anchorEl}
				open={submenuOpen}
				offset={0}
				placement="right"
			>
				<ActionList
					{...attrProps}
					setOpenAttribute={setOpenAttribute}
				/>
			</PopoverBase>
		</>
	);
};

export default ExpandingListItem;
